// extracted by mini-css-extract-plugin
export default {"buttons-container":"ApplicationAlert_buttons-container__IWSDG","align-center":"ApplicationAlert_align-center__v33hu","applicationError":"ApplicationAlert_applicationError__bywKE"};